import {forwardRef, Ref} from 'react';
import List, {IProps as IListProps, IListRef} from '../component/List';
import Loading from '../component/Loading';
import {useFetchInfo} from '../util/fetch';

interface IProps<K, T> extends Omit<IListProps<K, T>, 'isEnd'> {
  actionType: string;
  fetchKey?: string | number;
  isEnd?: boolean; // 입력하지 않으면 fetch info를 이용해서 자동으로 계산
}

function FetchList<K extends string, T extends {[key in K]: any}>(
  {items, actionType, fetchKey, isEnd, ...rest}: IProps<K, T>,
  ref: Ref<IListRef>
) {
  const {
    isFetching,
    isSlow,
    isFirstFetched,
    isEnd: isEndByRedux,
  } = useFetchInfo(actionType, fetchKey);

  return isFirstFetched ? (
    <List
      ref={ref}
      isFetching={isFetching}
      isSlow={isSlow}
      isEnd={isEnd ?? isEndByRedux}
      items={items}
      {...rest}
    />
  ) : (
    <Loading isFull />
  );
}

export default forwardRef(FetchList);
